"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const chatSlice_1 = __importDefault(require("./slices/chatSlice"));
const userSlice_1 = __importDefault(require("./slices/userSlice"));
const profileSlice_1 = __importDefault(require("./slices/profileSlice"));
const staticDataSlice_1 = __importDefault(require("./slices/staticDataSlice"));
const preloaderSlice_1 = __importDefault(require("./slices/preloaderSlice"));
const expertsSlice_1 = __importDefault(require("./slices/expertsSlice"));
const modalsSlice_1 = __importDefault(require("./slices/modalsSlice"));
const paymentSlice_1 = __importDefault(require("./slices/paymentSlice"));
const userHistorySlice_1 = __importDefault(require("./slices/userHistorySlice"));
const whatsNewSlice_1 = __importDefault(require("./slices/whatsNewSlice"));
const newsFeedSlice_1 = __importDefault(require("./slices/newsFeedSlice"));
const lawFirmSlice_1 = __importDefault(require("./slices/lawFirmSlice"));
const lawFirmProfileSlice_1 = __importDefault(require("./slices/lawFirmProfileSlice"));
const notificationCenterSlice_1 = __importDefault(require("./slices/notificationCenterSlice"));
const subscriptionSlice_1 = __importDefault(require("./slices/subscriptionSlice"));
const combinedReducers = toolkit_1.combineReducers({
    profile: profileSlice_1.default,
    chat: chatSlice_1.default,
    user: userSlice_1.default,
    staticData: staticDataSlice_1.default,
    preloader: preloaderSlice_1.default,
    experts: expertsSlice_1.default,
    modals: modalsSlice_1.default,
    payment: paymentSlice_1.default,
    userHistory: userHistorySlice_1.default,
    whatsNew: whatsNewSlice_1.default,
    newsFeed: newsFeedSlice_1.default,
    lawFirm: lawFirmSlice_1.default,
    lawFirmProfile: lawFirmProfileSlice_1.default,
    notificationCenter: notificationCenterSlice_1.default,
    subscription: subscriptionSlice_1.default
});
const rootReducer = (state, action) => {
    if (action.type === 'staticData/resetStore') {
        state = undefined;
    }
    return combinedReducers(state, action);
};
exports.default = rootReducer;
